const FORBIDDEN_SPEAKER_LABEL_CHARACTERS = /[:\r\n]/;

export function getSpeakerLabelValidationError(label: string): string | null {
  const trimmed = label.trim();

  if (!trimmed) {
    return 'Speaker label cannot be empty';
  }

  if (FORBIDDEN_SPEAKER_LABEL_CHARACTERS.test(trimmed)) {
    return 'Speaker label cannot contain colon or line breaks';
  }

  return null;
}
